export class CostReviewFireEnUsSystemInterfaces {
  systemInterfaces!: number[];
  fireSmokeDampers!: number[];
  ledAnnunciator!: number[];
  alphaNumericAnnunciator!: number[];
  otherNotes!: string;
  isSystemInterfacesApplicable!: boolean;
}
